import React from 'react';
import Dialog from './Dialog';
import useDialogMutation from '../hooks/useDialogMutation';

function ConfirmExpenseDeleteDialog({ expense, onConfirm, onClose }) {
  const { run, saving, error } = useDialogMutation();

  return (
    <Dialog title={`Delete "${expense.name}"?`} onClose={onClose} locked={saving}>
      <p className="dialog-text">This removes the recurring expense and updates your burn rate. This can't be undone.</p>
      {error && <p className="dialog-error" role="alert">{error}</p>}
      <div className="dialog-actions">
        <button type="button" className="btn" onClick={onClose} autoFocus disabled={saving}>Cancel</button>
        <button
          type="button"
          className="btn btn-danger"
          disabled={saving}
          onClick={() => run(() => onConfirm(expense.id), onClose)}
        >
          {saving ? 'Deleting…' : 'Delete'}
        </button>
      </div>
    </Dialog>
  );
}

export default ConfirmExpenseDeleteDialog;